import DoDisturbOnSharpIcon from '@mui/icons-material/DoDisturbOnSharp'
import LoopSharpIcon from '@mui/icons-material/LoopSharp'
import NotInterestedSharpIcon from '@mui/icons-material/NotInterestedSharp'
import { ParseKeys } from 'i18next'
import { ReactNode } from 'react'
import { CheckStatusEnum } from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'
import { ChipStatus } from '~/shared/ui/Chips'
import {
  CheckCircleIcon,
  InfoCircleIcon,
  PauseCircleIcon,
  SlashCircleIcon,
} from '~/shared/ui/Icons'

type CheckStatusProps = {
  value: CheckStatusEnum | 'NO_RESULTS'
}

export function CheckStatus({ value }: CheckStatusProps) {
  const { Icon, label, color } = statuses[value]
  return <ChipStatus labelI18n={label} variant={color} startDecorator={Icon} />
}

const statuses: Record<
  CheckStatusProps['value'],
  {
    Icon: ReactNode
    label: ParseKeys
    color: string
  }
> = {
  [CheckStatusEnum.NOT_FOUND]: {
    Icon: <NotInterestedSharpIcon />,
    label: 'status.no results found',
    color: 'yellow',
  },
  [CheckStatusEnum.IN_PROGRESS]: {
    Icon: <LoopSharpIcon />,
    label: 'status.in progress',
    color: 'gray',
  },
  [CheckStatusEnum.SUCCESS]: {
    Icon: <CheckCircleIcon />,
    label: 'status.results received',
    color: 'green',
  },
  [CheckStatusEnum.TIMEOUT_REACHED]: {
    Icon: <PauseCircleIcon color={myPalette.yellow['600']} />,
    label: 'status.timed out',
    color: 'yellow',
  },
  [CheckStatusEnum.CANCELLATION_IN_PROGRESS]: {
    Icon: <DoDisturbOnSharpIcon />,
    label: 'status.cancelling',
    color: 'outlinedRed',
  },
  [CheckStatusEnum.CANCELLED]: {
    Icon: <DoDisturbOnSharpIcon />,
    label: 'status.cancelled',
    color: 'red',
  },
  [CheckStatusEnum.FAILED]: {
    Icon: <InfoCircleIcon color={myPalette.red['700']} />,
    label: 'status.error',
    color: 'red',
  },
  NO_RESULTS: {
    Icon: <SlashCircleIcon color={myPalette.red['700']} />,
    label: 'status.no results',
    color: 'red',
  },
}
